import { useEffect, useMemo, useState } from 'react';

import { findLateralMenagers } from 'services/profile.service';
import { User } from 'types/user';
import { getStorageItem } from 'utils/storage';

// Port 1:1 do ApreciarRealizacao/index.tsx (LAT-01): resolve o gestor "interno" — o
// substituído por lateralidade/férias — a partir do storage `manager_lateralidade`,
// validando a matrícula via find/get_gestor_prefixo. O evento `reload:lateralidade` é
// disparado no document (não no window) pelo Header/modal de lateralidade.
// O setLoading(true) que o original fazia no evento é responsabilidade da página do
// fluxo, que pode escutar o mesmo evento.
export function useLateralidade(user: User | undefined) {
  const [internalUser, setInternalUser] = useState<User>();

  useEffect(() => {
    if (!user) return;

    async function handleUser() {
      if (!!user) {
        const storedManager = getStorageItem('manager_lateralidade');

        if (!!storedManager && storedManager.length) {
          const vacationManagers = await findLateralMenagers(undefined, storedManager);

          const vacationManager = vacationManagers?.length
            ? vacationManagers.find((x: { _id: any }) => x._id === storedManager)
            : null;

          if (!!vacationManager?._id && !!vacationManager.extra?.id) {
            setInternalUser(vacationManager);
          } else {
            setInternalUser(user);
          }
        } else {
          setInternalUser(user);
        }
      }
    }

    function handleUserWLoading() {
      handleUser();
    }

    handleUser();

    document.addEventListener('reload:lateralidade', handleUserWLoading, false);

    return () => {
      document.removeEventListener('reload:lateralidade', handleUserWLoading);
    };
  }, [user]);

  const isVacationManager = useMemo(() => !!internalUser && !!user && internalUser._id !== user._id, [internalUser, user]);

  return { internalUser, isVacationManager };
}
